import { privateClient } from '.';

const path = '/atestes_de_campo';

async function Novo(dados) {
	return await privateClient({
		path: `${path}`,
		params: {
			method: 'POST',
			body: JSON.stringify(dados),
		},
	});
}

async function ConsultaPelaId(id) {
	return await privateClient({
		path: `${path}/${id}`,
	});
}

async function ListaTodos() {
	return await privateClient({
		path: `${path}`,
	});
}

async function Atualiza(id, dados) {
	return await privateClient({
		path: `${path}/${id}`,
		params: {
			method: 'PUT',
			body: JSON.stringify(dados),
		},
	});
}

async function RemovePelaId(id) {
	return await privateClient({
		path: `${path}/${id}`,
		params: {
			method: 'DELETE',
		},
	});
}

const atestesDeCampo = {
	Novo,
	ConsultaPelaId,
	ListaTodos,
	Atualiza,
	RemovePelaId,
};

export default atestesDeCampo;
